export {
  AGE_GATE_BLOCK_UNDER,
  AGE_GATE_THRESHOLDS,
} from './constants';
export { decideAgeGate } from './decide-age-gate';
export { evaluatePlatformAgeGate } from './request-platform-age-signal';
export { useAgeGateDecision } from './use-age-gate-decision';
export type {
  AgeGateDecision,
  AgeGateDecisionState,
  AgeGatePlatformSignal,
  AgeSignalsStatus,
  SignificantChangeStatus,
} from './types';
